import React, {Component} from "react"
import {Button, Divider, Modal} from "semantic-ui-react"
import SignatureDialog from "../SignatureDialog/SignatureDialog"
import api from "../../../api"
import {observer} from "mobx-react"
import {withTranslation, Trans} from 'react-i18next'

@observer
class SignatureStep extends Component {

  state = {
    name: "",
    open: true
  }

  saveSignature = () => {
    let signaturePad = this.signaturePad
    let { step }     = this.props
    let nosignature = "<Trans i18nKey=\"signature.no\">Leere Unterschrift/Kein Name</Trans>"

    if ( signaturePad ) {
      if ( signaturePad.isEmpty() || !signaturePad.name ) {
        window.alert( {nosignature} )
        return
      }
      let name  = signaturePad.name
      let files = getFilesFromSignaturePad( signaturePad, step )
      signaturePad.off()
      return api.postSignature( { files, step, name } )
        .then( res => {
          console.log( `res post signature`, res )
          this.forceUpdate()
        } )
    }
  }

  close = () => {this.setState( { open: false } )}
  open  = () => {this.setState( { open: true } )}

  render() {
    const { open } = this.state
    let { step }   = this.props
    if ( step.IsDone ) {
      return <div key={step.SortOrder}>
        <div className="tc"><Button circular color="green" icon="checkmark"/></div>
      </div>
    }

    const {t} = this.props;

    let signature = <Trans i18nKey="signature.signature">Unterschrift</Trans>
    let customerX = <Trans i18nKey="general.customerX">Kunde X</Trans>
    let stepName = step.Name;

    if ( step.Name === "Unterschrift Techniker" ) {
      stepName = <Trans i18nKey="signature.signatureTechnician">Unterschrift Techniker</Trans>
    }

    return (
      <div key={step.SortOrder}>
        {!open &&
        <div className="tc pa3"><Button color="green" onClick={this.open}>{t("signature.now")}</Button></div>}

        <Modal open={open} closeIcon={true} onClose={this.close} >
          <div className="pt2 pb4">
            <Divider horizontal>{stepName || {signature}}</Divider>
            <SignatureDialog
              showNameInput={true}
              onClose={this.close}
              setup={({ signaturePad }) => {
                this.signaturePad = signaturePad
              }}
              onSubmit={(signaturePad, name = {customerX}) => {
                this.close()
                this.saveSignature()
              }}>
            </SignatureDialog>
          </div>
        </Modal>
        {/*<pre>{JSON.stringify(step, null, 2)}</pre>*/}
      </div>
    )
  }
}

export default withTranslation()(SignatureStep)

const getFilesFromSignaturePad = (signaturePad, step) => {
  let dataUrl   = signaturePad.toDataURL( "image/jpg" )
  let name      = signaturePad.name
  let file      = api.dataURLtoBlob( dataUrl )
  file.filename = `Unterschrift ${name} - ${step.Id}`
  let files     = [ file ]
  return files
}



// WEBPACK FOOTER //
// ./src/pages/components/Step/SignatureStep.js